import { CellProps } from "react-table";
import { useGo } from "_utils/url";
import { useAttendanceStore } from "_api/hooks/attendances";
import { E } from "_pages/service/queue/entity";
import { Button, Buttons } from "_ui/Button";
import { toastRun } from "_utils/misc";
import { ClientOnline } from "_types/responses/Ws/desk/desk-client-online";
import { UserAttendanceStarted } from "_types/responses/user-attendance-started";
import { HearingHub } from "_services/ws/hearing-hub";
import { $currentAttendanceId } from "_pages/service/queue/state";

export const ActionsCell = ({ value, row: { original: client } }: CellProps<ClientOnline>) => {
    const go = useGo();
    const { mutateAsync: start, isPending: loading } = useAttendanceStore();

    const view = (id: string) => {
        go(E.url.view(id));
    }

    const startAttendance = async () => {
        await toastRun(
            start({
                clientServedId: client.id,
            }),
            (res: UserAttendanceStarted) => {
                const { chatSessionId, attendanceId, token } = res;
                $currentAttendanceId.set(attendanceId);
                HearingHub.currentChatId = chatSessionId;

                HearingHub.storeGeneratedToken(
                    chatSessionId,
                    attendanceId,
                    token,
                    false,
                );

                go(attendanceId);
            },
        )
    }

    return (
        <Buttons>
            {/*<ViewIconButton onClick={() => view(value)} tooltip={E.tip.view}/>*/}
            <Button icon='fas fa-headset' tooltip='Iniciar atendimento' onClick={startAttendance} {...{ loading }} />
        </Buttons>
    );
}
